import {takeEvery} from "redux-saga/effects";
import {getAllCouriersWorker, getAllPeriods} from "./commonWorkers"
import {getAllCouriers, getOperatorPeriodsInit} from "../../reducers/toolkit/comonReducer"

function* commonWatcher() {
    yield takeEvery(getOperatorPeriodsInit, getAllPeriods)
    yield takeEvery(getAllCouriers, getAllCouriersWorker)
}
export default commonWatcher;
